import {Badge, Grid, Stack} from '@mantine/core';
import {BillingProvider,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty,
    TabbedComponent,
    TabComponentTab,
} from "@flexinet/ui-components";
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import {CreatedByProfileFormatter, UserProfile} from "../../../components/CreatedByProfileFormatter.tsx";
import {IndexPage as PaymentProfilesPage} from "../../payment-profiles/pages/IndexPage.tsx";


export const Profile = ({record}: { record: BillingProvider }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Billing Provider Key',
            value: record.key as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Status',
            value: record.status && record.status === 'Enabled' ? <Badge color={'green'}>Enabled</Badge> :
                <Badge color={'red'}>Disabled</Badge>,
            span: 12,
        }, {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as unknown as UserProfile}/>,
            rbac: 'UpdateBillingProvider',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Updated By',
            value: typeof record.updatedBy !== 'undefined' && record.updatedBy !== null ? [record.updatedBy.givenName, record.updatedBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateBillingProvider',
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    const tabs = [
        {
            title: 'Payment Profiles',
            component: <PaymentProfilesPage billingProviderId={record.id}/>,
        },
    ] as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{base: 12, lg: 4}}>
                <Stack gap={'xl'}>
                    <PlatformPropertyCard properties={allowedProperties}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{base: 12, lg: 8}}>
                <TabbedComponent tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );
};
